import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../Header/Header.jsx';
import Footer from '../Footer/Footer.jsx';
import styles from './AnimatedGifCards.module.css';
import MalliakkaDancing from '../../images/malliakka-dance.mp4';
import ThathaJogging from '../../images/thatha-jogging.mp4';

const AnimatedCards = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mode, setMode] = useState('graphic');
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const cards = [
    {
      id: 1,
      title: "Malli Akka",
      subtitle: "Character Design",
      gif: MalliakkaDancing,
      link: "/character-design",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      id: 2,
      title: "Thatha & Puli",
      subtitle: "Character Design",
      gif: ThathaJogging,
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    }
  ];

  const handleCardClick = (card) => {
    if (card.id === 1) {
      navigate('/character-design');
    } else if (card.id === 2) {
      navigate('/thatapuli');
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <Header mode={mode} setMode={setMode} menuOpen={menuOpen} setMenuOpen={setMenuOpen} scrolled={scrolled} />
      <div className={styles.container}>
        <div className={styles.backgroundAnimation}>
          {[...Array(20)].map((_, i) => (
            <div key={i} className={styles.floatingOrb} style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }} />
          ))}
        </div>

        <div className={styles.headerSection}>
          <h1 className={styles.mainTitle}>
            Choose Your Adventure
          </h1>
          <div className={styles.titleDecoration} />
        </div>

        <div className={styles.cardsContainer}>
          {cards.map((card) => (
            <div
              key={card.id}
              className={styles.card}
              onMouseEnter={() => setHoveredCard(card.id)}
              onMouseLeave={() => setHoveredCard(null)}
              onClick={() => handleCardClick(card)}
            >
              <div className={styles.cardInner}>
                {card.gif && card.gif.includes && card.gif.includes('.mp4') ? (
                  <video 
                    autoPlay 
                    loop 
                    muted 
                    playsInline
                    className={styles.cardVideo}
                  >
                    <source src={card.gif} type="video/mp4" />
                  </video>
                ) : (
                  <div className={styles.cardBackground} style={{ backgroundImage: `url(${card.gif})` }} />
                )}
                <div className={styles.cardGradient} style={{ background: card.gradient }} />

                <div className={styles.cardContent}>
                  
                  
                  {/* <h2 className={styles.cardTitle}>{card.title}</h2>
                  <p className={styles.cardSubtitle}>{card.subtitle}</p> */}

                  <div className={styles.cardButton}>
                    <span>Explore Now</span>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                </div>

                <div className={styles.sparkles}>
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className={styles.sparkle} style={{
                      left: `${20 + i * 15}%`,
                      top: `${30 + (i % 2) * 40}%`,
                      animationDelay: `${i * 0.2}s`
                    }}>✨</div>
                  ))}
                </div>
              </div>

              <div className={styles.cardGlow} style={{ background: card.gradient }} />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.footerOverride}>
        <Footer />
      </div>
    </div>
  );
};

export default AnimatedCards;